export const CLIENT_CONFIG_DEFAULT_WIDGET_OPTIONS = {};
